// @ts-nocheck
import msalInstance from "../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { API_BASE_URL } from "./api";

const BACKEND_HOST = API_BASE_URL;
const SCOPE = (import.meta && import.meta.env && import.meta.env.VITE_PULSE_BACKEND_SCOPE) || "openid profile email api://309bcdf7-601c-4fca-9d61-4874a4ecf430/access_as_user";

async function acquireTokenForAccount(account) {
  try {
    const resp = await msalInstance.acquireTokenSilent({ scopes: SCOPE.split(" "), account });
    return resp && resp.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError || (err && err.errorCode === "interaction_required")) {
      // Background fetches should not force an interactive redirect.
      // Return null and let the app initiate login when appropriate.
      if ((import.meta && import.meta.env && import.meta.env.DEV)) {
        console.debug('[fetchWithMsal] interaction required for silent token acquisition; skipping redirect from fetch');
      }
      return null;
    }
    return null;
  }
}

export function installFetchAuth() {
  if (typeof window === "undefined" || !window.fetch) return;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    try {
      const url = typeof input === "string" ? input : input.url;
      if (url && url.includes(BACKEND_HOST)) {
        // get active account
        const accounts = msalInstance.getAllAccounts();
        const account = accounts && accounts.length ? accounts[0] : null;
        let token = null;
        if (account) token = await acquireTokenForAccount(account);
        // Debug: log token and decoded payload in dev
        try {
          const isDev = (import.meta && import.meta.env && import.meta.env.DEV) || false;
          if (isDev && token) {
            console.log("[fetchWithMsal] acquired access token:", token);
            try {
              const parts = token.split('.');
              if (parts.length >= 2) {
                const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
                console.log('[fetchWithMsal] access token payload:', payload);
              }
            } catch (e) {
              console.warn('[fetchWithMsal] failed to decode token payload', e);
            }
          }
        } catch (e) {}
        // attach Authorization header if token
        const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined) || {});
        if (token) headers.set("Authorization", `Bearer ${token}`);
        const newInit = { ...init, headers };
        return originalFetch(input, newInit);
      }
    } catch (e) {
      // ignore and fall back
    }
    return originalFetch(input, init);
  };
}

export default installFetchAuth;
